import { Button, createTheme, ThemeProvider } from "@mui/material";
import axios from "axios";
import React from "react";
import { useQuery } from "react-query";
import { useNavigate, useParams } from "react-router-dom";
import TableList from "./TableList";

const lightTheme = createTheme({
	palette: {
		mode: "light",
	},
});

const Manage = ({ token, setToken }) => {
	const history = useNavigate();

	const [printView, setPrintView] = React.useState(false);

	const api = axios.create({
		baseURL: "https://forum2023-be.vercel.app",
		headers: {
			Authorization: token,
		},
	});

	const getData = async () => {
		const { data } = await api.get("/report");
		return data;
	};

	const { data, isLoading, error, refetch } = useQuery(
		"participants",
		getData
	);

	const handleDelete = async (id, name) => {
		if (window.confirm(`точно видалити ${name}?`)) {
			api.delete(`/participants/${id}`);
			setTimeout(() => {
				refetch();
			}, 2000);
		}
	};
	if (isLoading) {
		return <>Loading</>;
	}

	if (error) {
		history("/login");
	}

	const daysArray = ["22.12", "23.12", "24.12", "25.12"];

	return (
		<>
			{!printView ? (
				<>
					<h3>Харчування</h3>
					{daysArray.map((day) => (
						<>
							<h4>{day}</h4>
							<p>Cніданок: {data.food[day].breakfast}</p>
							<p>Обід: {data.food[day].lunch}</p>
							<p>Вечеря: {data.food[day].dinner}</p>
						</>
					))}
					<h3>Список людей (всього {data?.fulllist.length})</h3>
					{data?.fulllist.map((item) => (
						<div
							style={{
								border: "1px solid lightgrey",
								marginBottom: 10,
								padding: 10,
							}}
						>
							<p>ПІБ: {item.name}</p>
							<p>Номер телефону: {item.phone}</p>
							<p>Звідки: {item.from}</p>
							<p>Вік: {item.age}</p>
							<p>Служитель: {item.servant}</p>
							<p>
								Проживання:{" "}
								{item.place === "other"
									? "Інше"
									: "Молитовний будинок"}
							</p>
							<Button
								variant="outlined"
								onClick={() =>
									handleDelete(item._id, item.name)
								}
							>
								delete
							</Button>
							<br />
						</div>
					))}
				</>
			) : (
				<ThemeProvider theme={lightTheme}>
					<TableList list={data} />
				</ThemeProvider>
			)}
		</>
	);
};

export default Manage;
